export default "__VITE_ASSET__627b1ccd__"